import { render, staticRenderFns } from "./ShareableGroupForm.vue?vue&type=template&id=73be8072&scoped=true&"
import script from "./ShareableGroupForm.vue?vue&type=script&lang=js&"
export * from "./ShareableGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be8072",
  null
  
)

export default component.exports